'use strict';

function getStatic(value) {
  return {
    tag: 'p',
    attrs: {
      className: {
        'form-control-static': true
      }
    },
    children: value
  };
}

module.exports = getStatic;


/*****************
 ** WEBPACK FOOTER
 ** ./~/tcomb-form/~/uvdom-bootstrap/lib/getStatic.js
 ** module id = 148
 ** module chunks = 0
 **/